import React from 'react';
import PropTypes from "prop-types";
import { create, all, ceil } from 'mathjs'
import { CSCContext } from "../CSCContext";
import NumberInput from "./NumberInput";

class CalculatedNumberDisplay extends React.PureComponent {
  static contextType = CSCContext;
  
  constructor(props) {
    super(props);
    this.newValue = null;
    const config = {};
    const math = create(all, config);
    try {
      this.expression = math.compile(props.value);
    } catch(error) {
      error.name = `Unable to compile mathjs expression from value ${props.value}`;
      console.error(error);
    }
  }

  calculateValue() {    
    let calculatedValue = "";
    const userData = this.context.getUserData()

    try {
      calculatedValue = this.expression.evaluate(userData); 
      calculatedValue = ceil(calculatedValue);
      
    } catch (error) {
      // sometimes we need to try to calculate multiple times until all required values are included in userData
      // Not the most efficient, but there ya go. Let's not warn to console in production.
      //console.warn(`Current state insufficient to evaluate "${this.props.value}"\n ${error}`);
    }

    if (calculatedValue !== userData[this.props.name]) {
      this.newValue = calculatedValue;
    } else {
      this.newValue = null;
    }

    return(calculatedValue);
  }

  componentDidUpdate() {
    if (this.newValue) {
      // only update the main userData if my value has changed
      this.context.setUserData(this.props.name, this.newValue);
    }
  }

  render() {
    return (
      <div id={this.props.name} className="calculated-number-display">
        <label>{this.props.label + ' '}
          <NumberInput 
            name={this.props.name}
            value={this.calculateValue()}
            prefix={this.props.prefix}
            readOnly
          />
        </label>
      </div>
    );
  }
}

CalculatedNumberDisplay.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  label: PropTypes.string,
  prefix: PropTypes.string,
};

CalculatedNumberDisplay.defaultProps = {
  label: "",
  prefix: "",
}

export default CalculatedNumberDisplay;